export function ApiToken(){
    return process.env.REACT_APP_TOKEN
};

export function DomainName(){
    // return 'https://admin.alsubaee.com/'
    return 'https://admin.haramaynrooms.com/'
};
export function ApiEndPoint(){
    return 'https://api.synchtravel.com' 
};
export function CurrencyConverter(){
    return 'b8d4b285d48d1e690388e999'
};
export function StripeClientSecret(){
    // return process.env.REACT_APP_STRIPE_TEST
    return process.env.REACT_APP_STRIPE_LIVE
};
// b8d4b285d48d1e690388e999 with 30k hits
//32ce58d166a15bca2a55cd7a testing
// 8885028c6faaef9cb5bc397b new